import React, { useState } from "react";
import { sendForgotPasswordOTP, resetPasswordWithOTP } from "../api/otp";
import "./ForgotPassword.css";

export default function ForgotPassword() {
  const [step, setStep] = useState(1); // 1 = request OTP, 2 = reset
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  async function handleRequestOTP(e) {
    e.preventDefault();
    setMessage("");
    if (!email) {
      setMessage("Please enter your registered email.");
      setMessageType("error");
      return;
    }
    setIsLoading(true);
    try {
      const res = await sendForgotPasswordOTP(email);
      setMessage(res.message || "OTP sent to your email.");
      setMessageType("success");
      setStep(2);
    } catch (err) {
      console.error(err);
      setMessage(err.detail || err.message || "Failed to send OTP.");
      setMessageType("error");
    } finally {
      setIsLoading(false);
    }
  }

  async function handleResetPassword(e) {
    e.preventDefault();
    setMessage("");
    if (!otp || !newPassword) {
      setMessage("Please provide OTP and a new password.");
      setMessageType("error");
      return;
    }
    setIsLoading(true);
    try {
      const res = await resetPasswordWithOTP(email, otp, newPassword);
      setMessage(res.message || "Password updated successfully");
      setMessageType("success");
      // Optionally redirect to login after success
      setTimeout(() => {
        window.location.href = "/login";
      }, 1200);
    } catch (err) {
      console.error(err);
      setMessage(err.detail || err.message || "Failed to reset password.");
      setMessageType("error");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="forgot-container">
      <div className="forgot-card">
        <h2>{step === 1 ? "Reset Password" : "Enter OTP & New Password"}</h2>
        {message && <div className={`message ${messageType}`}>{message}</div>}

        {step === 1 ? (
          <form onSubmit={handleRequestOTP} className="forgot-form">
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" disabled={isLoading} className="btn">
              {isLoading ? "Sending..." : "Send OTP"}
            </button>
          </form>
        ) : (
          <form onSubmit={handleResetPassword} className="forgot-form">
            <label>OTP Code</label>
            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
            <label>New Password</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={6}
            />
            <div className="actions">
              <button type="button" className="btn alt" onClick={() => setStep(1)}>Back</button>
              <button type="submit" disabled={isLoading} className="btn">
                {isLoading ? "Updating..." : "Reset Password"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
